/* Fix del "2º producto no desliza" en los carruseles Flickity de producto.
   Flickity hace this.focus() en pointerdown (sobre elementos que no son input/select/
   textarea). En un carrusel con 2 tarjetas por vista, ese focus del elemento provoca
   un "scroll into view" que pega el drag al tocar la 2ª tarjeta.
   Solución: quitar el tabindex del contenedor Flickity → this.focus() ya no enfoca →
   no hay salto → el drag arranca parejo desde cualquier tarjeta.
   SIN MutationObserver (evitamos loops): un par de pasadas al cargar y listo. */
(function () {
  if (window.__ttFlickityFocusFix) return;
  window.__ttFlickityFocusFix = true;

  /* Antes este archivo se cargaba desde el snippet de la seccion, asi que solo
     estaba presente en paginas CON carruseles. Ahora se carga una sola vez desde
     layout/theme.liquid (para no duplicar la etiqueta), o sea que llega a todas
     las paginas. Sin esta salida temprana, en una ficha de producto o un 404 se
     ejecutarian igual los 8 ticks de 400 ms buscando algo que no existe.
     El contenedor lo pinta el servidor, y este script va con `defer`, asi que
     cuando corre el DOM ya esta parseado: si no hay carrusel, no lo habra. */
  if (!document.querySelector('.featured-collection__content')) return;

  function fix() {
    var els = document.querySelectorAll('.featured-collection__content.flickity-enabled[tabindex]');
    for (var i = 0; i < els.length; i++) {
      els[i].removeAttribute('tabindex');
      els[i].setAttribute('data-tt-focusfixed', '1');
    }
  }

  if (document.readyState === 'complete') fix();
  else window.addEventListener('load', fix);

  // Reintentos LIMITADOS por si Flickity arranca tarde (tope duro, sin loop)
  var tries = 0;
  var iv = setInterval(function () {
    fix();
    if (++tries >= 8) clearInterval(iv);
  }, 400);
})();
